const PhoneIcon = () => (
  <svg
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
    aria-hidden='true'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.1108 5.92578C12.852 5.92578 15.0744 8.1484 15.0744 10.8897'
      stroke='currentColor'
      strokeWidth='0.835881'
      strokeLinecap='round'
      strokeLinejoin='round' />
    <path
      d='M10.1108 3.46289C14.2109 3.46289 17.5374 6.78667 17.5374 10.89'
      stroke='currentColor'
      strokeWidth='0.835881'
      strokeLinecap='round'
      strokeLinejoin='round' />
    <path
      d='M10.1108 1C15.5728 1 20.0003 5.42784 20.0003 10.8902'
      stroke='currentColor'
      strokeWidth='0.835881'
      strokeLinecap='round'
      strokeLinejoin='round' />
    <path
      d='M2.16816 3.71204C-0.239749 6.12011 1.19457 11.455 5.37001 15.6307C9.54545 19.8064 14.8799 21.2379 17.2878 18.8328C18.018 18.1025 18.3484 16.445 18.3484 16.445C18.4034 16.1726 18.244 15.8683 17.9948 15.7669L13.6253 14.0195C13.3761 13.921 13.0081 14.0021 12.8081 14.205L11.5419 15.4713C11.3014 15.7118 10.9508 15.7727 10.6755 15.6481C10.6523 15.6365 10.632 15.6249 10.6118 15.6162C10.6031 15.6104 10.5944 15.6046 10.5857 15.5988C9.62369 15.0743 8.60662 14.3122 7.64752 13.353C6.68841 12.3939 5.92634 11.3767 5.40188 10.4147C5.39608 10.406 5.39319 10.3973 5.38739 10.3886C5.3758 10.3654 5.36421 10.3451 5.35262 10.3219C5.22802 10.0466 5.28887 9.696 5.52937 9.45548L6.79562 8.18914C6.99846 7.98919 7.07959 7.62117 6.98107 7.36906L5.23382 2.99918C5.1353 2.74997 4.83105 2.59059 4.55578 2.64565C4.55578 2.64565 2.89835 2.97599 2.16816 3.70624V3.71204Z'
      stroke='currentColor'
      strokeWidth='0.835881'
      strokeLinecap='round'
      strokeLinejoin='round' />
  </svg>
)

export default PhoneIcon